module.exports = __webpack_public_path__ + "video/900_SERF_2022_TargetedThreats.f231ef05.vtt";